import $ from "jquery";
(window as any).$ = $;
(window as any).jQuery = $;

import "jquery.maskedinput/src/jquery.maskedinput.js";

$(function () {
    $(".s-MaskedEditor").each(function () {
        const input = this as HTMLInputElement;

        if (input.value === "undefined") {
            input.value = "";
        }
    });
});

import { Authorization, Config, ErrorHandling, TranslationConfig } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import flatpickr from "flatpickr";
import "flatpickr/dist/l10n";
import { getLanguageList } from "./Helpers/LanguageList";
import DOMPurify from "dompurify";
import { IdleTimeout } from "./Helpers/IdleTimeout";

Config.rootNamespaces.push('WWSC.Reclaim.Web');
TranslationConfig.getLanguageList = getLanguageList;
gridDefaults.sanitizer = (globalThis.DOMPurify = DOMPurify).sanitize;

let culture = (document.documentElement?.lang || 'en').toLowerCase();
if (flatpickr.l10ns[culture]) {
    flatpickr.localize(flatpickr.l10ns[culture]);
} else {
    culture = culture.split('-')[0];
    flatpickr.l10ns[culture] && flatpickr.localize(flatpickr.l10ns[culture]);
}

window.onerror = ErrorHandling.runtimeErrorHandler;
window.addEventListener('unhandledrejection', ErrorHandling.unhandledRejectionHandler);

$(() => {
    var meta = $('meta[name=username]');
    if ((meta.length && meta.attr('content')) ||
        (!meta.length && Authorization.isLoggedIn)) {
        new IdleTimeout({
            activityTimeout: 20 * 60,
            warningDuration: 2 * 60
        });
    }
});
